import Page from "./project5/src/app/page";
import FramerMotion from "./react-framerMotion-ex/framerMotion";
import I18Next from "./react-i18next-ex/react-i18next";
import ReactSlick from "./react-slick-ex/react-slick";


const App = () => {
  return (
//<ReactSlick/>
//<I18Next/>
//<FramerMotion/>
<Page/>
   );
}
 
export default App;